<template>
  <div>
    <!-- slot for parent component to activate the file changer -->
    <div v-if="!isValid" class="error">{{ errorDescription }}</div>
    <div @click="launchFilePicker()">
      <slot name="activator"></slot>
    </div>
    <!-- image input: style is set to hidden and assigned a ref so that it can be triggered -->
    <input
      autocomplete="off"
      type="file"
      ref="file"
      :name="uploadFieldName"
      @change="onFileChange($event.target.name, $event.target.files)"
      style="display:none"
    />
  </div>
</template>

<script>
export default {
  data: () => ({
    errorDialog: null,
    errorText: "",
    base64Image: "",
    uploadFieldName: "file",
    maxSize: 2048,
    isValid: Boolean,
    errorDescription: "your image or PDF is not valid"
  }),
  props: {
    value: Object,
    validation: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    launchFilePicker() {
      this.$refs.file.click();
    },
    onFileChange(fieldName, file) {
      const { maxSize } = this;
      let imageFile = file[0];
      if (file.length > 0) {
        let size = imageFile.size / maxSize / maxSize;
        if (
          !imageFile.type.match("image.*") &&
          imageFile.type !== "application/pdf"
        ) {
          this.$swal(
            "Oops that went wrong?",
            `You haven't selected a correct image or PDF. Please try again.`,
            "error"
          );
        } else if (size > 2) {
          this.$swal(
            "Oops that went wrong?",
            `The filesize of this image is too large. Please compress the image or PDF and try again.`,
            "error"
          );
        } else {
          if (imageFile.type.match("image.*")) {
            let formData = new FormData();
            let imageURL = URL.createObjectURL(imageFile);

            var that = this;

            this.getBase64(imageFile).then(data => {
              that.base64Image = data;

              var base64 = this.base64Image;

              formData.append(fieldName, imageFile);
              this.$refs.file.value = null;
              // Emit the FormData and image URL to the parent component
              that.$emit("input", { formData, imageURL, base64 });
            });
          } else if (imageFile.type == "application/pdf") {
            var that = this;

            let url = this.$endpoint + "upload/pdf";
            let formData = new FormData();

            formData.append("file", file);
            formData.append(fieldName, imageFile);

            this.$http
              .post(url, formData, {
                headers: {
                  "Content-Type": "multipart/form-data"
                },
                processData: false,
                contentType: false
              })
              .then(function(response) {
                let imageURL= response.data.url
                let base64Response = response.data.image
                that.$emit("input", { imageURL, base64:base64Response });
              })
              .catch(function(error) {
                console.log(error)
                that.$swal(
                  "Oops that went wrong?",
                  `Please contact the admin with the following info: ${error}`,
                  "error"
                );
              });
          }
        }
      }
    },
    getBase64(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = error => reject(error);
      });
    }
  },
  watch: {
    validation: function(newVal, oldVal) {
      this.isValid = newVal;
    }
  }
};
</script>

<style lang="scss" scoped>
.error {
  color: #f27c7c;
  position: absolute;
  top: -20px;
  right: 0;
  font-size: 13px;
  font-weight: 500;
}
.valid,
.invalid {
  &::after {
    position: absolute;
    top: 50%;
    right: -20px;
  }
}
</style>
